import React from 'react';

import { PartyDialog } from 'src/components';
import { Apollo } from 'src/gql/generated';
import { useGetParty } from 'src/hooks';

interface EditPartyDialogProps {
  handleClose: () => void;
  open: boolean;
  partyId: UUID;
}

export function EditPartyDialog(props: EditPartyDialogProps): JSX.Element | null {
  const { partyId } = props;
  const { party } = useGetParty(partyId);
  const [updateParty] = Apollo.useUpdatePartyMutation();

  return (
    <PartyDialog
      handleSubmit={async ({ description, name }) => {
        await updateParty({
          variables: { input: { partyId, props: { description, name } } },
        });
      }}
      initialValues={{ description: party?.description ?? '', name: party?.name ?? '' }}
      submitText="Save"
      title="Edit party"
      {...props}
    />
  );
}
